// Private files: payment screenshots and payment QR images (ADR 0005). They never sit in the
// public upload folder; each opens only through the signed-in route, which checks who asks.
import { api, assetUrl } from './api';

// Mirror PRIVATE_IMAGE_MAX_BYTES and sniffImageType in the backend. The server checks the file's
// content again; these checks only spare the student a wasted upload.
export const PAYMENT_PROOF_TYPES = ['image/png', 'image/jpeg', 'image/webp'];
export const PAYMENT_PROOF_MAX_MB = 5;
const PAYMENT_PROOF_MAX_BYTES = PAYMENT_PROOF_MAX_MB * 1024 * 1024;
// A no-break space keeps "5 MB" on one line when the hint wraps.
const NO_BREAK_SPACE = String.fromCharCode(160);
export const PAYMENT_PROOF_ALLOWED = `PNG, JPEG or WebP, up to ${PAYMENT_PROOF_MAX_MB}${NO_BREAK_SPACE}MB`;

// The address of a private file, resolved against the API origin (dev runs the API on :3001).
export function privateFileUrl(id) {
  return id ? assetUrl(`/api/private-files/${id}`) : null;
}

// -> null when the file may be sent, or the message to show the student. One cause per message.
export function paymentProofProblem(file) {
  if (!file) return `Choose a screenshot of your payment (${PAYMENT_PROOF_ALLOWED}).`;
  if (!PAYMENT_PROOF_TYPES.includes(file.type)) {
    return `This file is not a PNG, JPEG or WebP image. Choose a screenshot (${PAYMENT_PROOF_ALLOWED}).`;
  }
  if (file.size > PAYMENT_PROOF_MAX_BYTES) {
    return `This image is larger than ${PAYMENT_PROOF_MAX_MB} MB. Choose a smaller screenshot (${PAYMENT_PROOF_ALLOWED}).`;
  }
  return null;
}

// Attach a payment screenshot to the student's own pending booking. -> { booking }
export function uploadPaymentProof(bookingId, file) {
  const formData = new FormData();
  formData.append('file', file);
  return api.post(`/bookings/${bookingId}/payment-proof`, formData);
}
